import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconMove = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M18 11h-5V6h3l-4-4-4 4h3v5H6V8l-4 4 4 4v-3h5v5H8l4 4 4-4h-3v-5h5v3l4-4-4-4z" }) }));
const Memo = memo(SvgIconMove);
export default Memo;
//# sourceMappingURL=IconMove.js.map